import script from "./8P68MYL.vue?vue&type=script&setup=true&lang=js"
export * from "./8P68MYL.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__